
import { en } from './en';
import { es } from './es';
import { Translations } from '../types';

export const translations: Translations = {
  en,
  es
};
